import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval, editApproval } from "./fssAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("fss/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "fss/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "fss/editApproval",
  async ({ id, params }) => {
    console.log(id, "id");
    console.log(params, "params");
    const response = await editApproval(id, params);
    return response;
  }
);

export const fssSlice = createSlice({
  name: "fss",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = fssSlice.actions;

export const selectData = (state) => state.fss.data;
export const selectLoading = (state) => state.fss.loading;
export const selectError = (state) => state.fss.error;
export const selectPageNo = (state) => state.fss.pageNo;
export const selectPageSize = (state) => state.fss.pageSize;
export const selectTotalRecord = (state) => state.fss.totalRecord;
export const selectSelected = (state) => state.fss.selected;
export const selectApproval = (state) => state.fss.approval;

export default fssSlice.reducer;
